// extracted by mini-css-extract-plugin
module.exports = {"submit-button-container":"premium-service-checker_submit-button-container__fHwLy","input-container":"premium-service-checker_input-container__Q2k4d"};